import { useUpdateEffect } from 'react-use';
import styled from 'styled-components';

import { useFormController } from '@dreryk/react-common';
import { ActionInput } from '@dreryk/react-components';

import { medicalDevicesTranslationKeys } from '../translations';

type MedicalDeviceOrdersHistorySearchProps = {
   readonly onSearchTextChanged: (searchText: string | null) => void;
};

type SearchTextFormBean = {
   searchText: string | null;
};

const StyledActionInput = styled(ActionInput)`
   max-width: 540px;
`;
StyledActionInput.displayName = 'ActionInput';

export const MedicalDeviceOrdersHistorySearch = (props: MedicalDeviceOrdersHistorySearchProps): JSX.Element => {
   const { register, watch } = useFormController<SearchTextFormBean>({
      searchText: null,
   });
   const searchText = watch('searchText');

   useUpdateEffect(() => {
      props.onSearchTextChanged(searchText);
   }, [searchText]);

   return (
      <StyledActionInput
         testId={'deviceHistorySearch'}
         controller={register('searchText')}
         placeholder={medicalDevicesTranslationKeys.historicalMedicalDeviceOrder.enterCodeOrDeviceName}
      />
   );
};
